import React, { useState } from "react";

// Input qty/usage dengan 4 angka di belakang koma.
// Saat tidak fokus tampil "1.234,5000"; saat diketik menerima koma atau titik
// sebagai pemisah desimal (maks. 4 digit). onChange menerima string ber-titik
// ("1234.5") atau "" — sama seperti ev.target.value input type="number" lama.
const fmt4 = (n) =>
  new Intl.NumberFormat("id-ID", { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(n);

export const formatQty = (n) => fmt4(Number(n) || 0);

function clean(raw) {
  const s = String(raw).replace(/[^\d.,]/g, "");
  const i = s.search(/[.,]/);
  if (i < 0) return s;
  return s.slice(0, i) + "," + s.slice(i + 1).replace(/[.,]/g, "").slice(0, 4);
}

export default function QtyInput({ value, onChange, className = "", ...rest }) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState("");
  const n = parseFloat(value);
  const has = value !== "" && value != null && !isNaN(n);

  return (
    <input
      type="text"
      inputMode="decimal"
      {...rest}
      className={className}
      value={focused ? draft : has ? fmt4(n) : ""}
      onFocus={(ev) => {
        setDraft(has ? String(n).replace(".", ",") : "");
        setFocused(true);
        rest.onFocus && rest.onFocus(ev);
      }}
      onBlur={(ev) => {
        setFocused(false);
        rest.onBlur && rest.onBlur(ev);
      }}
      onChange={(ev) => {
        const c = clean(ev.target.value);
        setDraft(c);
        onChange(c.replace(",", "."));
      }}
    />
  );
}
